import { render, staticRenderFns } from "./OverseasColumnSections.vue?vue&type=template&id=4e73eb13&scoped=true&"
import script from "./OverseasColumnSections.vue?vue&type=script&lang=js&"
export * from "./OverseasColumnSections.vue?vue&type=script&lang=js&"
import style0 from "./OverseasColumnSections.vue?vue&type=style&index=0&id=4e73eb13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73eb13",
  null
  
)

export default component.exports